<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Create Maintenance Request</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <div class="modal-intro-information">
                    <label>Title:</label>
                    <input ref="title" type="text" placeholder="Work Order Title" class="create-modal-title"
                        v-model="title" />
                    <label>Description:</label>
                    <textarea ref="description" type="text" placeholder="Description" class="create-modal-description"
                        maxlength="200" rows="5" v-model="description"></textarea>
                </div>
                <div class="modal-create-data">
                    <div class="modal-create-data-item">
                        <p>Unit*</p>
                        <input ref="unit" type="text" placeholder="Unit" class="modal-title" v-model="unit" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Location*</p>
                        <input ref="location" type="text" placeholder="Location" class="modal-title"
                            v-model="location" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Category*</p>
                        <input ref="category" type="text" placeholder="Category" class="modal-title"
                            v-model="category" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Status</p>
                        <input ref="status" type="text" placeholder="Status" class="modal-title" v-model="status" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Priority</p>
                        <input ref="priority" type="text" placeholder="Priority" class="modal-title"
                            v-model="priority" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Associated User</p>
                        <input ref="associated-user" type="text" placeholder="Associated User" class="modal-title"
                            v-model="associatedUser" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>Assigned To</p>
                        <input ref="assigned-to" type="text" placeholder="Assigned To" class="modal-title"
                            v-model="assignedTo" />
                    </div>
                </div>
            </div>
            <div class="modal-footer reverse">
                <div class="toggle-container">
                    <SlideToggle v-model="sendNotifications" />
                    <p>1099 Eligible?</p>
                </div>
                <button @click="() => alert('Create Incident')">Create Maintenance Request</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";
import SlideToggle from "../pages/pageComps/SlideToggle.vue";

const NAME = Constants.CREATE_MAINTENANCE_MODAL

export default {
    components: {
        SlideToggle
    },
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
    }
}
</script>
<style></style>